export const environment = {
  apiUrl: 'https://brinks.techcrowd.space/AiApi',
  production: false,
};

